import styled from 'styled-components'

const H6 = styled.h6``

export default H6
